
import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { AddAccountForm } from './AddAccountForm';
import { useTranslation } from 'react-i18next';

interface CompleteAddAccountDialogProps {
  isOpen: boolean;
  onClose: () => void;
  botId: string;
  onSuccess: () => void;
}

export const CompleteAddAccountDialog = ({ 
  isOpen, 
  onClose, 
  botId,
  onSuccess 
}: CompleteAddAccountDialogProps) => {
  const { t } = useTranslation();

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[500px]">
        <DialogHeader>
          <DialogTitle>{t('add_new_account')}</DialogTitle>
        </DialogHeader>
        <AddAccountForm
          botId={botId}
          onSuccess={onSuccess}
          onCancel={onClose}
        />
      </DialogContent>
    </Dialog>
  );
};
